/** The first criterion a candidate fails, in the order HR reads them. */
export const INELIGIBLE_REASONS = [
    'STATUS',
    'EMPLOYMENT_TYPE',
    'JOINED_AFTER',
    'NOT_CONFIRMED',
];
/**
 * Why a candidate is not eligible, or null when every criterion holds: status on the cutoff in
 * the chosen statuses (never Upcoming / Exited), employment type in the chosen types, joined on
 * or before the joining limit and confirmed on or before the confirmation limit (each optional).
 */
export function specialRunIneligibility(candidate, criteria) {
    const statuses = criteria.statuses;
    if (!statuses.includes(candidate.status))
        return 'STATUS';
    if (!candidate.employmentType || !criteria.employmentTypes.includes(candidate.employmentType)) {
        return 'EMPLOYMENT_TYPE';
    }
    if (criteria.joinedOnOrBefore && candidate.joiningDate > criteria.joinedOnOrBefore) {
        return 'JOINED_AFTER';
    }
    if (criteria.confirmedOnOrBefore &&
        (!candidate.confirmationDate || candidate.confirmationDate > criteria.confirmedOnOrBefore)) {
        return 'NOT_CONFIRMED';
    }
    return null;
}
//# sourceMappingURL=eligibility.js.map